import React from 'react';
import * as Sentry from '@sentry/react';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({ errorInfo: errorInfo });

    // Report to Sentry if configured
    if (process.env.REACT_APP_SENTRY_DSN) {
      Sentry.captureException(error, { contexts: { react: { componentStack: errorInfo.componentStack } } });
    }
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI when an error occurs
      return (
        <div className="error-boundary">
          <div className="error-icon">⚠️</div>
          <h3 className="error-title">Something went wrong</h3>
          <p className="error-message">
            {this.state.error?.message || 'This component failed to load.'}
          </p>
          {this.props.fallback && (
            <div className="error-fallback">
              {this.props.fallback}
            </div>
          )}
          <button
            className="error-retry"
            onClick={() => window.location.reload()}
          >
            Reload Page
          </button>
          {process.env.NODE_ENV === 'development' && (
            <div className="error-details">
              <details>
                <summary>Technical Details</summary>
                <pre className="error-stack">
                  {this.state.error?.stack}
                </pre>
              </details>
            </div>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;